import type { ToolCategoryDefinition } from "./types";

export const toolCategories: ToolCategoryDefinition[] = [
  {
    name: "Conversion Tools",
    slug: "conversion-tools",
    href: "/tools/conversion-tools",
    description:
      "Use the Snappy Fix image converter tool to effortlessly change photo file types. Convert PNG to JPG free, swap WebP, and decode Base64 with zero data loss.",
    longDescription:
      "Welcome to the ultimate high resolution picture converter. Our conversion tools category brings together browser-based utilities to safely change image formats exactly how you need them. Whether you want a reliable Base64 image decoder, need to convert JPG to PNG free, switch between WebP formats, or convert multiple images to PDF, Snappy Fix gives you lightning-fast processing with zero data loss. Use our low to high quality image converter, change picture to JPG online, and discover how to change photo file types seamlessly with practical tools built for everyday file workflows.",
    keywords: [
      "snappy fix image converter tool",
      "how to change photo file type",
      "bulk transform picture to jpg free",
      "low to high quality image maker",
      "extension format inspector online",
      "change multiple photos to pdf",
      "base64 image decoder for developers",
      "webp to png quality checker",
      "change picture to jpg without blurring",
      "high resolution picture converter",
      "convert png to jpg online",
      "best image conversion app",
    ],
  },
  {
    name: "PDF Tools",
    slug: "pdf-tools",
    href: "/tools/pdf-tools",
    description:
      "Manage and optimize files with the Snappy Fix PDF suite. Compress large PDF files, edit documents online free, and securely convert images to PDF.",
    longDescription:
      "Take full control of your workflow with the Snappy Fix PDF suite, a browser-based collection of tools for converting, compressing, editing, merging, splitting, and managing PDF files online. Whether you need a secure document converter or a reliable PDF page manager, our tools require no software installation. Use our image to PDF converter to turn photos into PDF, convert documents to images, compress large PDF files, reduce PDF file size free, and make files smaller online with an integrated PDF file size checker. Edit PDF online free, merge multiple PDFs into a single file, or split PDF pages online with fast, secure processing.",
    keywords: [
      "snappy fix pdf suite",
      "best free document editor",
      "compress large documents",
      "pdf file size checker",
      "split pages without sign up",
      "image to pdf converter app",
      "make file smaller online",
      "convert document to images",
      "pdf workflow manager app",
      "edit documents free online",
      "turn photos into pdf",
      "portable document format tool",
    ],
  },
  {
    name: "Editing Tools",
    slug: "image-editing-tools",
    href: "/tools/image-editing-tools",
    description:
      "Edit images in browser with the best online photo editor. A free picture editing website to crop, change image size online, and enhance visual quality.",
    longDescription:
      "No need for heavy desktop programs like Photoshop. Our suite of online editing tools lets you seamlessly edit pictures in your browser. Whether you need a free photo cropping tool, want to change image size online, make precise color adjustments, apply watermarks, or change DPI, Snappy Fix helps you handle image editing tasks quickly without downloads. Maintain visual quality, adjust photos for real use cases, and edit image files with practical browser-based tools built for speed.",
    keywords: [
      "snappy fix image editor",
      "edit picture in browser",
      "best online photo editor",
      "free graphic editing website",
      "photo enhancement software online",
      "change image size fast",
      "free photo cropping tool",
      "online visual editing apps",
      "picture resolution analyzer tool",
      "website to resize graphics",
      "browser based photograph inspector",
      "image dimensions converter utility",
    ],
  },
  {
    name: "Optimization Tools",
    slug: "image-optimization-tools",
    href: "/tools/image-optimization-tools",
    description:
      "Compress JPEG online free and reduce image size without losing quality. Use our pagespeed image optimizer to shrink files by 80% and boost loading speed.",
    longDescription:
      "Snappy Fix optimization tools help you reduce file size without sacrificing clarity. If you are looking for how to compress JPEG online free, shrink image weight, or create cleaner WebP files for faster performance, this category brings together advanced compression and optimisation workflows in one place. These tools help you reduce image size without losing quality, improve upload speed, cut bandwidth usage, and prepare image assets for better page performance across websites, landing pages, stores, and content platforms.",
    keywords: [
      "snappy fix optimizer",
      "compress jpeg online free",
      "reduce image size without losing quality",
      "how to reduce file size of photo",
      "pagespeed image performance analyzer",
      "online photo compressor app",
      "svg image optimizer tool",
      "free picture weight reducer",
      "website asset optimization checker",
      "lossless image compression maker",
      "webp conversion tool online",
      "boost loading speed with compression",
    ],
  },
  {
    name: "Analysis Tools",
    slug: "image-analysis-tools",
    href: "/tools/image-analysis-tools",
    description:
      "Use our online metadata viewer to view EXIF data online. Check image resolution, get color schemes, and inspect image properties instantly.",
    longDescription:
      "Deep dive into your visual assets with the Snappy Fix image analyzer category. Our online photo metadata viewer helps you view EXIF data online, extract hidden metadata properties, and inspect image details instantly. Need to match a design? Use our color picker from image online to identify hex code colors and get a color scheme from any image or graphic. To guarantee technical accuracy, our visual asset resolution tools let you check image dimensions online, inspect DPI, and verify specifications fast, all inside your browser.",
    keywords: [
      "snappy fix image analyzer",
      "view exif data online",
      "photo size checker",
      "get color scheme from graphic",
      "online image dpi inspector",
      "extract hidden metadata properties",
      "check picture dimensions fast",
      "visual asset resolution utility",
      "read photo details app",
      "identify hex code colors",
      "inspect image properties instantly",
      "online metadata viewer software",
    ],
  },
  {
    name: "Security Tools",
    slug: "security-tools",
    href: "/tools/security-tools",
    description:
      "Discover how to safely share photos online with our image meta data remover. Remove metadata from JPG, erase EXIF data, and use our strong password generator.",
    longDescription:
      "Privacy matters. With Snappy Fix security tools, you can keep your visual content and digital footprint secure in the browser. If you are wondering how to safely share photos online, our image metadata remover helps strip GPS data, clear hidden photo information, and erase EXIF data before uploading. You can remove metadata from JPG files, use an image GPS location scrubber, and protect identity with fast privacy-focused workflows. Beyond photos, we also provide a strong password generator online and password strength checker to support everyday security tasks.",
    keywords: [
      "snappy fix security tools",
      "how to safely share photos online",
      "password strength checker online",
      "remove metadata from jpg",
      "strong password generator online",
      "clear hidden photo information",
      "best way to create a password",
      "erase digital footprint exif data",
      "secure random password creator",
      "privacy app for visual content",
      "image gps location scrubber",
      "protect identity before uploading",
    ],
  },
  {
    name: "Social Media Tools",
    slug: "social-media-tools",
    href: "/tools/social-media-tools",
    description:
      "Perfectly resize image for social media. Our app to resize photos for social media includes a facebook cover photo resizer and handles Twitter image sizing.",
    longDescription:
      "Stop guessing aspect ratios and test visual content requirements easily. With Snappy Fix social media tools, you get a complete collection of browser-based resizing tools to automatically format creative assets for major platforms. Whether you need to resize photos for social media to prevent posts from getting cut off, check Twitter image sizing, prepare a Facebook cover, resize a YouTube thumbnail, or create a WhatsApp DP without cropping, these tools help you match the right dimensions fast. From Instagram post aspect ratios to LinkedIn headers, Snappy Fix helps you perfectly resize image assets for social media across every major platform.",
    keywords: [
      "snappy fix social media tools",
      "twitter image sizing checker",
      "social networks photo resizing app",
      "analyze facebook post dimensions",
      "facebook cover photo resizer",
      "youtube banner size converter",
      "format portrait for profile online",
      "whatsapp dp converter without cropping",
      "instagram post aspect ratio maker",
      "test visual content requirements",
      "linkedin header resolution inspector",
      "online picture scale tool",
    ],
  },
  {
    name: "SEO Tools",
    slug: "image-seo-tools",
    href: "/tools/image-seo-tools",
    description:
      "Enhance search engine visibility with our seo image optimizer. Use the favicon online maker to generate favicon from png and convert logo to favicon.",
    longDescription:
      "Improve your technical SEO and alt-text strategies with Snappy Fix SEO tools. Ensure your branding is consistent and create web-ready assets with our favicon online maker, favicon generator for website use cases, and browser-based image optimisation tools. You can generate favicon from PNG, convert logo to favicon, change JPG to ICO, and prepare multi-size assets for real publishing workflows. This category also helps you inspect visual branding assets, optimize images for Core Web Vitals, and improve the performance of image-heavy pages with practical SEO-focused utilities.",
    keywords: [
      "snappy fix seo tools",
      "generate favicon from png",
      "favicon online maker app",
      "convert logo to website icon",
      "seo image performance analyzer",
      "change jpg to ico format",
      "webp visual converter utility",
      "optimize images for core web vitals",
      "responsive app icon resizer",
      "check favicon 32x32 dimensions",
      "favicon generator 48x48 software",
      "inspect web branding assets",
    ],
  },
];

// TODO: rewrite this focusing on these keywords for seo performance
// keep the name, slug and href same
// the description is the meta descriptoin so obey metadescription rules while applying seo
// this write up is more of an update so any important word in the write up I gave you to thats not in the keywords should be retained in a creative way in the writeup

// Conversion Tools

// change image format
// convert picture to jpg
// change photo to jpg
// convert multiple images to pdf
// low quality to high quality image converter
// convert photo to png
// change picture format
// change file to jpg
// high quality picture converter
// convert png to jpg free
// low to high quality image converter
// photo into jpg
// change picture to jpeg format
// convert jpg to png free
// convert to jpg online
// how to change photo file type

// Metakeyword [
// "snappy fix image converter tool",
// "how to change photo file type",
// "bulk transform picture to jpg free",
// "low to high quality image maker",
// "extension format inspector online",
// "change multiple photos to pdf",
// "base64 image decoder for developers",
// "webp to png quality checker",
// "change picture to jpg without blurring",
// "high resolution picture converter",
// "convert png to jpg online",
// "best image conversion app"
// ]

// PDF Tools

// pdf tools online
// best pdf editor online
// document converter
// best free online pdf editor
// compress large pdf files
// make pdf file smaller
// reduce pdf file size free
// compress pdf tool
// pdf suite
// edit pdf online free no sign up
// split pdf pages online
// pdf page manager
//  Metakeyword :[
// "snappy fix pdf suite",
// "best free document editor",
// "compress large documents",
// "pdf file size checker",
// "split pages without sign up",
// "image to pdf converter app",
// "make file smaller online",
// "convert document to images",
// "pdf workflow manager app",
// "edit documents free online",
// "turn photos into pdf",
// "portable document format tool"
// ]

// Editing Tools

// edit image in browser
// image editing tool online
// best online photo editor
// editing website free
// photo editing website
// free picture editing
// photo editing tool
// photo editing software online
// change image size online
// free editing software for pictures
// photo editing sites
// free photo cropping tool
// online editing apps

// Meta keywords: [
// "snappy fix image editor",
// "edit picture in browser",
// "best online photo editor",
// "free graphic editing website",
// "photo enhancement software online",
// "change image size fast",
// "free photo cropping tool",
// "online visual editing apps",
// "picture resolution analyzer tool",
// "website to resize graphics",
// "browser based photograph inspector",
// "image dimensions converter utility"
// ]

// Optimization tools
// compress jpeg online free
// reduce image size without losing quality
// how to reduce file size of photo
// reduce image size without losing quality
// compress image without losing quality
// resize image size without losing quality
// compress picture without losing quality
// pagespeed image optimizer
// pagespeed image optimizer
// online photo compressor
// free image compressor online
// image size compressor online free
//  Metakey words  “[
// "snappy fix optimizer",
// "compress jpeg online free",
// "reduce image size without losing quality",
// "how to reduce file size of photo",
// "pagespeed image performance analyzer",
// "online photo compressor app",
// "svg image optimizer tool",
// "free picture weight reducer",
// "website asset optimization checker",
// "lossless image compression maker",
// "webp conversion tool online",
// "boost loading speed with compression"
// ]
// Analysis Tools
// view exif data online
// online metadata viewer
// online meta data viewer
// online photo metadata viewer
// color picker from image online
// get color scheme from image
// check image resolution online
// online image dpi checker
// check image dimensions online
// photo size checker
// image size checker online
// Meta keyword:[
// "snappy fix image analyzer",
// "view exif data online",
// "photo size checker",
// "get color scheme from graphic",
// "online image dpi inspector",
// "extract hidden metadata properties",
// "check picture dimensions fast",
// "visual asset resolution utility",
// "read photo details app",
// "identify hex code colors",
// "inspect image properties instantly",
// "online metadata viewer software"
// ]

// Security Tools"

// image meta data remover
// remove metadata from jpg
// how to safely share photos online
// strong password generator online
// random password generator free
// password generation tool
// password strength checker online
// best way to create a password
// clear metadata from photo
// erase exif data

// metakeywords:[
// "snappy fix security tools",
// "how to safely share photos online",
// "password strength checker online",
// "remove metadata from jpg",
// "strong password generator online",
// "clear hidden photo information",
// "best way to create a password",
// "erase digital footprint exif data",
// "secure random password creator",
// "privacy app for visual content",
// "image gps location scrubber",
// "protect identity before uploading"
// ]

// social-media-tools

// Twitter image sizing
// resize image for social media
// app to resize photos for social media
// facebook post image size
// facebook cover photo resizer
// youtube thumbnail resizer
// resize photo for facebook profile
// youtube banner size converter
// whatsapp dp size converter without cropping
// online photo resizer for whatsapp dp

// metakeywords:[
// "snappy fix social media tools",
// "twitter image sizing checker",
// "social networks photo resizing app",
// "analyze facebook post dimensions",
// "facebook cover photo resizer",
// "youtube banner size converter",
// "format portrait for profile online",
// "whatsapp dp converter without cropping",
// "instagram post aspect ratio maker",
// "test visual content requirements",
// "linkedin header resolution inspector",
// "online picture scale tool"
// ]

// SEO Tools

// generate favicon from png
// favicon online maker
// favicon generator for website
// convert logo to favicon
// seo image optimizer
// change jpg to ico
// image converter webp
// optimize images for core web vitals
// icon resizer
// favicon 32x32 generator
// favicon generator 48x48

// Meta keywords: [
// "snappy fix seo tools",
// "generate favicon from png",
// "favicon online maker app",
// "convert logo to website icon",
// "seo image performance analyzer",
// "change jpg to ico format",
// "webp visual converter utility",
// "optimize images for core web vitals",
// "responsive app icon resizer",
// "check favicon 32x32 dimensions",
// "favicon generator 48x48 software",
// "inspect web branding assets"
// ]
